module.exports = {
    SERVER_URL : process.env.REACT_APP_SERVER_URL === undefined?'':process.env.REACT_APP_SERVER_URL,
    GET_FILE_URL: process.env.REACT_APP_SERVER_URL === undefined?"http://localhost:5010/esigndev":process.env.REACT_APP_SERVER_URL,
    SERVER_CONTEXT_PATH : process.env.REACT_APP_SERVER_CONTEXT_PATH === undefined?"/esigndev":process.env.REACT_APP_SERVER_CONTEXT_PATH,
    ESIGN_ENVIRONMENT : process.env.REACT_APP_ESIGN_ENVIRONMENT === undefined?'':process.env.REACT_APP_ESIGN_ENVIRONMENT
}
